var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrders = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "52px",
    viewBox: "0 0 45 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "67A064D9-EFF3-4BC7-9C72-5DE541289225") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preparer---overview-select",
    transform: "translate(-317.000000, -33.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(317.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/orders",
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6592576,52 L34.3407424,52 C38.1689054,52 41.3726872,49.1591905 41.7939413,45.3910476 L44.988348,16.9191905 C45.0477236,16.3942381 44.8783469,15.8692857 44.5220934,15.4755714 C44.1670899,15.0818571 43.6589598,14.8571429 43.1252045,14.8571429 L33.7501116,14.8571429 L33.7501116,11.1428571 C33.7501116,4.99819048 28.7038115,0 22.5,0 C16.2961885,0 11.2498884,4.99819048 11.2498884,11.1428571 L11.2498884,14.8571429 L1.87479546,14.8571429 C1.34104016,14.8571429 0.832910125,15.0818571 0.477906604,15.4755714 C0.121653071,15.8692857 -0.0477236085,16.3942381 0.0116519803,16.9191905 L3.20480865,45.3910476 C3.62731284,49.1591905 6.83171962,52 10.6592576,52 Z M14.9999256,11.1428571 C14.9999256,7.04661905 18.364334,3.71428571 22.5,3.71428571 C26.635666,3.71428571 30.0000744,7.04661905 30.0000744,11.1428571 L30.0000744,14.8571429 L14.9999256,14.8571429 L14.9999256,11.1428571 Z M11.2498884,18.5714286 L11.2498884,22.2857143 C10.2142532,22.2857143 9.37486984,23.1170952 9.37486984,24.1428571 C9.37486984,25.168619 10.2142532,26 11.2498884,26 L14.9999256,26 C16.0355609,26 16.8749442,25.168619 16.8749442,24.1428571 C16.8749442,23.1170952 16.0355609,22.2857143 14.9999256,22.2857143 L14.9999256,18.5714286 L30.0000744,18.5714286 L30.0000744,22.2857143 C28.9644391,22.2857143 28.1250558,23.1170952 28.1250558,24.1428571 C28.1250558,25.168619 28.9644391,26 30.0000744,26 L33.7501116,26 C34.7857468,26 35.6251302,25.168619 35.6251302,24.1428571 C35.6251302,23.1170952 34.7857468,22.2857143 33.7501116,22.2857143 L33.7501116,18.5714286 L41.0301838,18.5714286 L38.0664044,44.9812381 C37.8564023,46.865619 36.2538864,48.2857143 34.3407424,48.2857143 L10.6592576,48.2857143 C8.74548859,48.2857143 7.14359771,46.865619 6.93234561,44.9812381 L3.96981623,18.5714286 L11.2498884,18.5714286 Z"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orders.a53866e5cdc2f6594eff59cfa7241741.svg";